import React from 'react';
import Dialog from '../dialog';
import { Formik } from 'formik';
import ButtonSubmit from 'components/form/formik/button-submit';
import { Col } from 'components/layout/layout';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { EDialogFormTypes, TDialogForm } from './index.types';
import { FormControlButtons, FormFields, FormStyled } from './index.styled';
import { EButtonSize, EButtonType } from '../../control/button/button.types';
import Button from '../../control/button/button';

const DialogForm = <TValues,>({
    isDialogOpen,
    setIsDialogOpen,
    title,
    initValues,
    onSubmit,
    validate,
    children,
    labels,
    isLoading,
    onCancel,
    dialogFormType,
}: React.PropsWithChildren<TDialogForm<TValues>>) => {
    return (
        <Dialog
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={title}
        >
            <Formik
                initialValues={initValues}
                onSubmit={async (values) => {
                    await onSubmit(values);
                    setIsDialogOpen(false);
                }}
                validate={validate}
            >
                <FormStyled justify={'start'}>
                    <FormFields justify={'start'}>{children}</FormFields>
                    <FormControlButtons>
                        <ButtonSubmit isLoading={isLoading}>
                            <Col gap={0.5}>
                                {dialogFormType === EDialogFormTypes.Add && (
                                    <AddCircleOutlineIcon />
                                )}
                                {labels?.submit ? labels.submit : title}
                            </Col>
                        </ButtonSubmit>
                        <Button
                            size={EButtonSize.Small}
                            onClick={() => {
                                onCancel && onCancel();
                                setIsDialogOpen(false);
                            }}
                            styleType={EButtonType.Outline}
                        >
                            {'Cancel'}
                        </Button>
                    </FormControlButtons>
                </FormStyled>
            </Formik>
        </Dialog>
    );
};

export default DialogForm;
